/**
 * Calculate the value of a function
 *
 * Instead of:
 * ```ts
 * const getBoolean = () => {
 *    /// some logic
 * }
 *
 * const result = getBoolean();
 * ```
 *
 * Use:
 * ```ts
 * const result = calculate(() => {
 *   /// some logic
 * }
 * ```
 * @param fn
 */
export const calculate = <T>(fn: () => T) => {
  return fn();
};
